class EditorialTabs extends HTMLElement {
  constructor() {
    super();
    this.rowsPerPage = parseInt(this.dataset.rowsPerPage, 10) || 5;
    this.pills = Array.from(this.querySelectorAll('.editorial-tabs__pill'));
    this.panels = Array.from(this.querySelectorAll('.editorial-tabs__panel'));
    this.page = new Map();
    this.panels.forEach((panel) => this.page.set(panel, 1));

    this.pills.forEach((pill) => {
      pill.addEventListener('click', () => this.switchTab(pill));
    });

    this.panels.forEach((panel) => {
      const btn = this.getLoadMoreButton(panel);
      if (btn) {
        btn.addEventListener('click', () => {
          this.page.set(panel, (this.page.get(panel) || 1) + 1);
          this.paginate(panel);
        });
      }
    });

    window.addEventListener(
      'resize',
      this.debounce(() => {
        const active = this.panels.find((panel) => panel.classList.contains('is-active'));
        if (active) this.paginate(active);
      }, 150)
    );

    // Run once layout has settled so offsetTop reflects the real grid.
    requestAnimationFrame(() => {
      const active =
        this.panels.find((panel) => panel.classList.contains('is-active')) || this.panels[0];
      if (active) this.paginate(active);
    });
  }

  getLoadMoreButton(panel) {
    return panel.querySelector('.editorial-tabs__load-more');
  }

  debounce(fn, wait) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn(...args), wait);
    };
  }

  switchTab(pill) {
    const id = pill.dataset.editorialTab;

    this.pills.forEach((p) => p.classList.toggle('is-active', p === pill));
    this.panels.forEach((panel) => {
      panel.classList.toggle('is-active', panel.dataset.editorialPanel === id);
    });

    const activePanel = this.panels.find((panel) => panel.dataset.editorialPanel === id);
    if (activePanel) {
      // Wait a frame so the panel is actually laid out before measuring it.
      requestAnimationFrame(() => this.paginate(activePanel));
    }
  }

  // Groups cards into rows by comparing their offsetTop. This works no
  // matter how many columns a given breakpoint uses, including a layout
  // where the first row has 1 card and later rows have 2+.
  getRows(cards) {
    const rows = [];
    let currentTop = null;

    cards.forEach((card) => {
      const top = card.offsetTop;
      if (currentTop === null || Math.abs(top - currentTop) > 2) {
        rows.push([]);
        currentTop = top;
      }
      rows[rows.length - 1].push(card);
    });

    return rows;
  }

  paginate(panel) {
    const grid = panel.querySelector('.editorial-tabs__grid');
    const btn = this.getLoadMoreButton(panel);
    if (!grid) return;

    const cards = Array.from(grid.querySelectorAll('.editorial-tabs__card'));
    if (!cards.length) {
      if (btn) btn.hidden = true;
      return;
    }

    // Reset visibility so offsetTop reflects the natural, un-hidden layout.
    cards.forEach((card) => {
      card.style.display = '';
    });

    const rows = this.getRows(cards);
    const page = this.page.get(panel) || 1;
    const cutoff = page * this.rowsPerPage;

    rows.slice(cutoff).forEach((row) => {
      row.forEach((card) => {
        card.style.display = 'none';
      });
    });

    if (btn) {
      btn.hidden = rows.length <= cutoff;
    }
  }
}

if (!customElements.get('editorial-tabs')) {
  customElements.define('editorial-tabs', EditorialTabs);
}